const appConfig = require(`@/companys/${process.env.COMPANY}/configurations/app-configs/config`)

export const iTradeEnv = appConfig.config